import { stdObject } from "../../../../data/types/stdObject";

export const updateCommissions = ({ index, key, value, data }: stdObject) => {
  data.forEach((e: stdObject, idx: number) => {
    if (e.PAGCOY === 0 && e.LINCOY === index) {
      data[idx] = { ...e, [`${key}COY`]: value };
    }
  });
  return data;
};
